<template>
  <div class="page-content">
    <page-template ref="batchTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
    ></page-template>

    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800"
               :close-on-click-modal="false">
      <good-list :isSelect="true" :tableOptions="showOptions" @selectSubmit="rowsSelectSubmit"></good-list>
    </el-dialog>
  </div>
</template>
<script>
  import pageTemplate from '@/components/template/pageTemplate';
  //商品列表组件
  import goodList from '@/components/business/goodList';
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate,
      goodList
    },
    data() {
      return {
        listShow: false,
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: '', prop: 'otherName', type: 'input', ifFuzzy: true, placeholder: "商品名称/条码"},
          ],
          complex: []
        },
        // 更多功能
        toolConfig: [
          {
            label: "删除",
            callback: this.deleteGoods,
            code: 'delete',
          },
          {
            label: "刷新",
            callback: this.refresh,
            code: 'refresh',
          },
          {
            label: "选择商品",
            callback: this.checkGoods,
            code: 'selectGoods',
          },
        ],
        // 表格信息配置
        tableOptions: {
          //showSelect: true,
          indexShow: true,//是否显示索引
          param: {freshGoods: 1},
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '100',
              align: 'center'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '90',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '90',
              align: 'center'
            },
            {
              label: '进货价',
              prop: 'buyPrice',
              width: '90',
              align: 'center'
            },
            {
              label: '批发价',
              prop: 'tradePrice',
              width: '90',
              align: 'center'
            },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '90',
              align: 'center'
            },
          ],
          url: api.archives.goodsInfo
        },
        //checkIndex: '',
        // 表格信息配置
        showOptions: {
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '200',
              align: 'center'
            },
            {
              label: "品名",
              prop: "goodsName",
              width: "120",
              align: "center"
            },
            {
              label: "规格",
              prop: "specs",
              width: "100",
              align: "center"
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '100',
              align: 'center'
            },
            {
              label: '进货价',
              prop: 'buyPrice',
              width: '90',
              align: 'center'
            },
            {
              label: '批发价',
              prop: 'tradePrice',
              width: '90',
              align: 'center'
            },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '90',
              align: 'center'
            },
          ],
          url: api.archives.goodsInfoIncludeSpecs
        },
      };
    },
    methods: {
      checkGoods() {
        this.listShow = true;
      },
      refresh() {
        this.$router.go(0);
      },
      rowsSelectSubmit(rows) {
        this.listShow = false;
        this.updateAsGoods(this.getSearchParam(rows, 1));
      },
      deleteGoods(data) {
        //let tableRows = this.$refs.batchTemplate.getTableSelectRow();
        this.$confirm("是否确认删除{" + data.id + "}生鲜产品?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //this.updateAsGoods(this.getSearchParam(tableRows, 0));
          let ids = [];
          ids.push(data.id);
          let searchParam = {ids: ids, freshGoods: false};
          this.updateAsGoods(searchParam);
        })
      },
      getSearchParam(row, params) {
        let ids = row.map(item => {
          return item.id;
        });
        return {
          ...{ids: ids}, freshGoods: params
        };
      },
      updateAsGoods(searchParam) {

        this.$axios
          .fetchPost(api.archives.goodsInfo + '/update/params', searchParam)
          .then(data => {
            this.loading = false;
            if (data.code == 200) {
              this.$router.go(0);
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        });
      }
    }

  };
</script>




// WEBPACK FOOTER //
// src/page/weigh/speciality/Fresh.vue